module.exports = __webpack_public_path__ + "static/img/mast.bdf3a38.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/mast.png
// module id = sPj0
// module chunks = 4